import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

// The TIMED_HOLD set ceiling, counted down at the top centre of the screen while
// a hold set runs.
//
// Deliberately NOT the set countdown: that one lives in the corner readout stack
// and freezes whenever the backend raises `holdTimerPaused`, which is exactly
// what strands a patient who cannot hold the position above the quality
// threshold. This clock runs through a red frame, a low score and an empty frame
// alike (see resolveRemainingSetCeilingTime) and stops only where the session
// itself stops — the pause modal. Whichever of the two reaches 0 first ends the
// set; the backend owns that call, this is only the readout for it.
//
// dir="ltr": a video overlay control, not reading-direction content — Arabic
// must not flip the label/value order or the chip's own centring.
const SetCeilingCountdown = ({ value, hasFpsOverlay = false }) => {
  const { t } = useTranslation('exercise');

  if (!value) {
    return null;
  }

  return (
    <div
      dir="ltr"
      tw="pointer-events-none fixed inset-x-0 z-[240] flex justify-center px-4"
      // Ducks under the dev FPS pill (fixed, top-4) while it is showing, the same
      // way the TIMED_REPS countdown chip does, instead of overlapping it.
      css={hasFpsOverlay ? tw`top-[84px]` : tw`top-4`}
      data-testid="set-ceiling-countdown"
    >
      <div tw="flex items-center gap-3 rounded-[10px] bg-[rgba(24,24,24,0.5)] px-[20px] py-[5px] text-white">
        {/* tabular-nums so the chip doesn't resize as the digits change. */}
        <span tw="min-w-[5ch] text-center text-[28px] font-bold tabular-nums [font-family: Roboto, sans-serif] lg:text-[40px]">
          {value}
        </span>
      </div>
    </div>
  );
};

export default SetCeilingCountdown;
